<div class="row">
  <div class="col-md-12">
    <button mat-raised-button class="edit-button" (click)="editParticipants()">
      @if (!participantEditMode) {
        <span>Edit</span>
      }
      @if (participantEditMode) {
        <span>Save</span>
      }
    </button>
  </div>
</div>
<div class="row align-top gutters">
  <div class="col-md-6">
    <div class="subsection-header orange-dark">CREA Participants
    </div>
    <div class="mat-elevation-z8">
      @if (!participantEditMode) {
        <table mat-table class="stripped-table" #creaTable
          #creaSort="matSort" [dataSource]="creaDataSource" matSort>
          <!-- Role Column -->
          <ng-container matColumnDef="role">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Role </th>
            <td mat-cell class="name-column" *matCellDef="let row"> {{row.role}} </td>
          </ng-container>
          <!-- Participant Column -->
          <ng-container matColumnDef="participant">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Participant </th>
            <td mat-cell *matCellDef="let row"><a href="{{row.url}}" target="_blank">{{row.participant}}</a>@if (row.role === 'Originator') {
            <span> {{isOriginatedFormat(row.originatorRelationship)}}</span>
          }</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="creaColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: creaColumns;"></tr>
      </table>
    }

    @if (participantEditMode) {
      <table mat-table class="stripped-table" #creaTable
        #creaSort="matSort" [dataSource]="creaEditData" matSort>
        <!-- Role Column -->
        <ng-container matColumnDef="role">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Role </th>
          <td mat-cell class="name-column" *matCellDef="let row; let i = index"> {{row.role.name}}
            @if (permsService.userPerms['ROLE'][row.role.id]['_edit']) {
              <button mat-mini-fab (click)="addCREAParticipant(i);" class="attribute-buttons">
                <mat-icon>add</mat-icon>
              </button>
            }
          </td>
        </ng-container>
        <!-- Participant Column -->
        <ng-container matColumnDef="participant">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Participant </th>
          <td mat-cell *matCellDef="let row; let i = index">
            @if (permsService.userPerms['ROLE'][row.role.id]['_edit']) {
              @for (part of row.data; track part; let j = $index) {
                <div>
                  <mat-form-field class="full-width">
                    <input matInput [formControl]="getSearchParticipant(i,j,'crea', row.role, part)"
                placeholder="{{ row.data[j].participant
                  ? row.data[j].participant.person ? row.data[j].participant.person.name
                  : row.data[j].participant.organization ? row.data[j].participant.organization.name
                    : ''
                : ''
                }}"
                      [matAutocomplete]="searchauto" (focus)="initializeAutocomplete(row.role, 'crea')">
                  </mat-form-field>
                  <mat-autocomplete #searchauto="matAutocomplete" [displayWith]="participantOptionText">
                    @for (val of currentSearchResults; track val) {
                      <mat-option
                        [value]="val"
                        (click)="updateCREAParticipant(i, j, val);"
                        >
                        {{val.participant.name}}
                      </mat-option>
                    }
                  </mat-autocomplete>
                  <button mat-mini-fab (click)="deleteCREAParticipant(i,j);" class="attribute-buttons">
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
              }
            }
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="creaColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: creaColumns;"></tr>
      </table>
    }
  </div>
</div>
<div class="col-md-6">
  <div class="row sponsor-table">
    <div class="subsection-header blue">Sponsor Participants</div>
    <div class="mat-elevation-z8">
      @if (!participantEditMode) {
        <table mat-table class="stripped-table" #sponsorTable #sponsorSort="matSort" matSort [dataSource]="sponsorDataSource">
          <!-- Role Column-->
          <ng-container matColumnDef="role">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Role </th>
            <td mat-cell class="name-column" *matCellDef="let row">{{row.role}}</td>
          </ng-container>
          <ng-container matColumnDef="participant">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Participant </th>
            <td mat-cell *matCellDef="let row"><a href="{{row.url}}" target="_blank">{{row.participant}}</a></td>
          </ng-container>
          <ng-container matColumnDef="repeat">
            <th mat-header-cell *matHeaderCellDef>Repeat Sponsor</th>
            <td mat-cell *matCellDef="let row">{{row.is_repeat}}</td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="sponsorColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: sponsorColumns;"></tr>
        </table>
      }

      @if (participantEditMode) {
        <table mat-table class="stripped-table" #sponsorTable
          #sponsorSort="matSort" [dataSource]="sponsorEditData" matSort>
          <!-- Role Column -->
          <ng-container matColumnDef="role">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Role </th>
            <td mat-cell class="name-column" *matCellDef="let row; let i = index"> {{row.role.name}}
              @if (permsService.userPerms['ROLE'][row.role.id]['_edit'] && row.role.name!=='Sponsor') {
                <button mat-mini-fab (click)="addSponsorParticipant(i);" class="attribute-buttons">
                  <mat-icon>add</mat-icon>
                </button>
              }
            </td>
          </ng-container>
          <!-- Participant Column -->
          <ng-container matColumnDef="participant">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Participant </th>
            <td mat-cell *matCellDef="let row; let i = index">
              @if (permsService.userPerms['ROLE'][row.role.id]['_edit']) {
                @for (part of row.data; track part; let j = $index) {
                  <div>
                    <mat-form-field class="full-width">
                      <input matInput [formControl]="getSearchParticipant(i,j,'sponsor', row.role, part)"
                           placeholder="{{ row.data[j].participant
                  ? row.data[j].participant.person ? row.data[j].participant.person.name
                  : row.data[j].participant.organization ? row.data[j].participant.organization.name
                  : row.data[j].participant.sponsor ? row.data[j].participant.sponsor.name
                    : ''
                : ''
                }}"
                        [matAutocomplete]="searchauto" (focus)="initializeAutocomplete(row.role, 'sponsor')">
                    </mat-form-field>
                    <mat-autocomplete #searchauto="matAutocomplete" [displayWith]="participantOptionText">
                      @for (val of currentSearchResults; track val) {
                        <mat-option
                          [value]="val"
                          (click)="updateSponsorParticipant(i, j, val);"
                          >
                          {{val.participant.name}}
                        </mat-option>
                      }
                    </mat-autocomplete>
                    <button mat-mini-fab (click)="deleteSponsorParticipant(i,j);" class="attribute-buttons">
                      <mat-icon>close</mat-icon>
                    </button>
                  </div>
                }
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="repeat">
            <th mat-header-cell *matHeaderCellDef>Repeat Sponsor</th>
            <td mat-cell *matCellDef="let row">{{row.is_repeat}}</td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="sponsorColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: sponsorColumns;"></tr>
        </table>
      }
    </div>
  </div>
  <div class="row">
    <div class="subsection-header orange">Third Party Participants

      <span class="save-icon">
        <!--            <mat-icon>edit</mat-icon>-->
      </span>
    </div>
    <div class="mat-elevation-z8">
      @if (!participantEditMode && !isMobile) {
        <table mat-table class="stripped-table" #thirdPartyTable
          #thirdPartySort="matSort" [dataSource]="thirdPartyDataSource" matSort>
          <!-- Role Column -->
          <ng-container matColumnDef="role">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Role </th>
            <td mat-cell class="name-column" *matCellDef="let row"> {{row.role}} </td>
          </ng-container>
          <!-- Participant Column -->
          <ng-container matColumnDef="participant">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Participant </th>
            <td mat-cell *matCellDef="let row"><a href="{{row.url}}" target="_blank">{{row.participant}}</a></td>
          </ng-container>
          <!-- Sponsor Column -->
          <ng-container matColumnDef="sponsor">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Sponsor </th>
            <td mat-cell *matCellDef="let row"><a href="{{row.sponsorurl}}" target="_blank">{{row.sponsor}}</a></td>
          </ng-container>
          <!-- Repeat Column -->
          <ng-container matColumnDef="repeat">
            <th mat-header-cell *matHeaderCellDef>Repeat Sponsor</th>
            <td mat-cell *matCellDef="let row">{{row.is_repeat}}</td>
          </ng-container>
          <!-- Tags Column -->
          <ng-container matColumnDef="tags">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Tags </th>
            <td mat-cell *matCellDef="let row">{{row.tags}}</td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="thirdPartyColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: thirdPartyColumns;"></tr>
        </table>
      }
      @if (!participantEditMode && isMobile) {
        <table mat-table class="stripped-table" #thirdPartyTable
          #thirdPartySort="matSort" [dataSource]="thirdPartyDataSource" matSort>
          <!-- Role Column -->
          <ng-container matColumnDef="role">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Participant </th>
            <td mat-cell class="name-column" *matCellDef="let row">
              <span class="name-column">
                {{row.role}}
              </span><br>
              <a href="{{row.url}}" target="_blank">{{row.participant}}</a><br>
              @if (row.sponsorurl) {
                <span>Sponsor: <a href="{{row.sponsorurl}}" target="_blank">{{row.sponsor}}</a><br></span>
              }
              @if (row.tags) {
                <span>({{row.tags}})</span>
              }
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="thirdPartyColumnsLite"></tr>
          <tr mat-row *matRowDef="let row; columns: thirdPartyColumnsLite;"></tr>
        </table>
      }
      @if (participantEditMode) {
        <table mat-table class="stripped-table" #creaTable
          #creaSort="matSort" [dataSource]="thirdEditData" matSort>
          <!-- Role Column -->
          <ng-container matColumnDef="role">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Role </th>
            <td mat-cell class="name-column" *matCellDef="let row; let i = index"> {{row.role.name}}
              @if (permsService.userPerms['ROLE'][row.role.id]['_edit'] && row.role.name !== 'Developer') {
                <button mat-mini-fab (click)="addThirdParticipant(i);" class="attribute-buttons">
                  <mat-icon>add</mat-icon>
                </button>
              }
            </td>
          </ng-container>
          <!-- Participant Column -->
          <ng-container matColumnDef="participant">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Participant </th>
            <td mat-cell *matCellDef="let row; let i = index">
              @if (permsService.userPerms['ROLE'][row.role.id]['_edit']) {
                @for (part of row.data; track part; let j = $index) {
                  <div>
                    <mat-form-field class="full-width">
                      <input matInput [formControl]="getSearchParticipant(i,j,'third', row.role, row.data[j])" [matAutocomplete]="searchauto"
                           placeholder="{{row.data[j].participant
                  ? row.data[j].participant.person ? row.data[j].participant.person.name
                  : row.data[j].participant.organization ? row.data[j].participant.organization.name
                  : row.data[j].participant.sponsor ? row.data[j].participant.sponsor.name
                    : ''
                : ''
                }}"  (focus)="initializeAutocomplete(row.role, 'third')">
                    </mat-form-field>
                    <mat-autocomplete #searchauto="matAutocomplete" [displayWith]="participantOptionText">
                      @for (val of currentSearchResults; track val) {
                        <mat-option
                      [value]=" val.name ? val.name : val.participant
                  ? val.participant.name
                    ?val.participant.name
                    : val.person
                      ? val.person.name
                      : val.organization
                        ? val.organization.name
                        : ''
                  :''"
                          (click)="updateThirdParticipant(i, j, val);"
                          >
                          {{val.participant.name}}
                        </mat-option>
                      }
                    </mat-autocomplete>
                    <button mat-mini-fab (click)="deleteThirdParticipant(i,j);" class="attribute-buttons">
                      <mat-icon>close</mat-icon>
                    </button>
                  </div>
                }
              }
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="creaColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: creaColumns;"></tr>
        </table>
      }
    </div>
  </div>


</div>
</div>
